(function () {
    _.datatables = _.datatables || {};
    _.datatables.renderer = _.datatables.renderer || {};

    /**
     * Extends datatables renderer to render dates in the ago format using moment
     * @param data
     * @param type
     * @param full
     * @returns {string}
     */
    _.datatables.renderer.dateAgo = function (data, type, full) {
        return moment(data).fromNow();
    };

    /**
     * Extends datatables to render dates in the ago format using moment
     * @param data
     * @param type
     * @param full
     * @returns {string}
     */
    _.datatables.renderer.dateFuture = function (data, type, full) {
        return moment(data).fromNow();
    };

    /**
     * Extends datatables renderer to render dates in the format YYYY-MM-DD hh:mm:ss A
     * @param data
     * @param type
     * @param full
     * @returns {string}
     */
    _.datatables.renderer.date = function (data, type, full) {
        return moment(data).format("YYYY-MM-DD hh:mm:ss A")
    };

    /**
     * Extends datatables renderer to format currency values appropriately
     * @param data
     * @param type
     * @param full
     * @returns {*|number}
     */
    _.datatables.renderer.currency = function (data, type, full) {
        var value = data || 0;
        var money = value.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,"); //http://stackoverflow.com/a/14428340
        if (type === "display") {
            return _.template("{{symbol}}&nbsp;{{ money }}")({
                symbol: currencySymbol,
                money: money
            });
        } else {
            return value;
        }
    };

    let currencySymbol = "¤"; // this is the generic currency symbol; app should update it from DashboadConfig
    _.datatables.renderer.configureCurrencySymbol = function(symbol) {
        currencySymbol = symbol;
    }


    /**
     * Pads a value with leading zeros
     * @param value {number}
     * @param width {number}
     * @param ?char {string} defaults to 0
     * @returns {*}
     */
    _.padLeft = function (value, width, char) {
        char = char || "0";
        var sValue = value + "";
        return sValue.length >= width ? sValue : new Array(width = sValue.length + 1).join(char) + sValue;
    };


//Set the template settings for placeholder tags to be in {{tag}} form
    _.templateSettings = {
        interpolate: /\{{2,3}(.+?)\}{2,3}/g

    };
})();
